import React, { useState, useEffect } from 'react';

function AddItemDialog({ onClose, onSave, initialData }) {
    const [itemData, setItemData] = useState(initialData || {
        name: '',
        description: '',
        price: '',
        taxPercent: '',
        quantity: 1,
        isExpense: false
    });

    useEffect(() => {
        if (initialData) setItemData(initialData);
    }, [initialData]);

    const handleSave = () => {
        if (!itemData.name.trim() || !itemData.price || isNaN(itemData.price) || Number(itemData.quantity) < 1) {
            return;
        }
        onSave({
            ...itemData,
            price: parseFloat(itemData.price)
        });
    };

    return (
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
                <div className="dialog-header">
                    <h3>{initialData ? 'Edit Invoice Item' : 'Add Invoice Item'}</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="dialog-body">
                    <div className="form-group">
                        <label>Item Name *</label>
                        <input
                            type="text"
                            placeholder="e.g., Plumbing service"
                            value={itemData.name}
                            onChange={(e) => setItemData({...itemData, name: e.target.value})}
                            autoFocus
                        />
                    </div>
                    <div className="form-group">
                        <label>Description</label>
                        <input
                            type="text"
                            placeholder="e.g., Kitchen sink repair"
                            value={itemData.description}
                            onChange={(e) => setItemData({...itemData, description: e.target.value})}
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Price (€) *</label>
                            <input
                                type="number"
                                placeholder="0.00"
                                value={itemData.price}
                                onChange={(e) => setItemData({...itemData, price: e.target.value})}
                                min="0"
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <label>Tax (%)</label>
                            <input
                                type="number"
                                placeholder="0"
                                min="0"
                                max="100"
                                value={itemData.taxPercent || ''}
                                onChange={e => setItemData({ ...itemData, taxPercent: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Quantity *</label>
                        <input
                            type="number"
                            placeholder="1"
                            value={itemData.quantity}
                            onChange={(e) => setItemData({...itemData, quantity: parseInt(e.target.value) || 1})}
                            min="1"
                        />
                    </div>
                    <div className="form-group checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                checked={itemData.isExpense}
                                onChange={(e) => setItemData({...itemData, isExpense: e.target.checked})}
                            />
                            Mark as expense
                        </label>
                    </div>
                </div>
                <div className="dialog-footer">
                    <button className="btn-cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="btn-save"
                        onClick={handleSave}
                        disabled={
                            !itemData.name.trim() ||
                            !itemData.price ||
                            isNaN(itemData.price) ||
                            Number(itemData.quantity) < 1
                        }
                        style={(!itemData.name.trim() || !itemData.price || isNaN(itemData.price) || Number(itemData.quantity) < 1) ? { background: '#e0e0e0', color: '#aaa', border: 'none', cursor: 'not-allowed', opacity: 0.7 } : {}}
                    >
                        {initialData ? 'Update' : 'Add Item'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AddItemDialog;
